import React from 'react';

const Header = ({ isMobile }) => {
  return (
    <header className={`header ${isMobile ? 'mobile-header' : ''}`}>
      <img 
        src="/logo1.png" 
        alt="Company Logo" 
        className="logo" 
        style={isMobile ? { height: '50px', marginLeft: '10px' } : {}}
      />
    </header>
  );
};

export default Header;